module.exports = __webpack_public_path__ + "static/img/about-list2.47f45a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/about-list2.png
// module id = 03EN
// module chunks = 1